import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Lock from '@material-ui/icons/Lock';
import logo from "../assets/logo.png";
import { loginAction, forgotPasswordAction } from "../actions/SessionAction";
import { connect } from "react-redux";
import { compose } from "redux";
const { innerWidth } = window;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '70%',
        maxHeight: '100%',

    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(100% - ${theme.spacing.unit * 2}px)`
    },
    input: {
        display: 'none',
    },
    inputStyle: {
        padding: '12px 5px',
        fontSize: 15,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    margin: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
    },
    gradientBackground: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        // background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
        transition: '1200ms',
        zIndex: 3,
        // opacity: 0.7
    },
    paper: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        // padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5

    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-34px' : '-34px',
        marginTop: innerWidth >= 480 ? '-34px' : '-44px'
    },
    typography : {
        color: "blue",
        cursor: "pointer",
    }
})

class Login extends Component {

    static contextTypes = {
        router: PropTypes.object,
    }

    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            email_error: false,
            invalid_email_error: false,
            password_error: false,
            invalid_password_error: false,
            loginErrorMsg:"",
            open: false,
            status: ""
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    submitForm = () => {
        let { email, password } = this.state;
        let isError = false

        if (email !== null && email !== "") {
            if (!this.validateEmail(this.state.email)) {
                this.setState({ invalid_email_error: true })
                isError = true
            }
        } else {
            this.setState({ email_error: true })
            isError = true
        }

        if (password !== null && password !== "") {
            if (!(password.length >= 8)) {
                this.setState({ invalid_password_error: true })
                isError = true
            }
        } else {
            this.setState({ password_error: true })
            isError = true
        }
        if (isError === false) {
            let userObj = {};
            userObj.email = email.trim();
            userObj.password = password;
            this.props.dispatch(loginAction(this, userObj,this.props.launchHeaderThis))           
        }
    }
    forgotPasswordSubmit = () => {
        let { email } = this.state;
        let isError = false

        if (email !== null && email !== "") {
            if (!this.validateEmail(this.state.email)) {
                this.setState({ invalid_email_error: true })
                isError = true
            }
        } else {
            this.setState({ email_error: true })
            isError = true
        }
        if (isError === false) {
            let userObj = {};
            userObj.email = email.trim();
            this.props.dispatch(forgotPasswordAction(this, userObj, this.props.launchHeaderThis))           
        }
    }

    handleOpen =() => {
        this.setState({ open: true})
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root} >
                <Grid container spacing={0}>
                    <Grid container item xs={6} className={classes.gradientBackground}>
                        <Grid item xs={12} style={{ justifyContent: "center", alignSelf: "center" }}>
                            <img src={logo} className={classes.img} alt="Logo" />
                        </Grid>
                    </Grid>
                    {this.state.open !== true ?
                    <Grid item xs={6} style={{ paddingTop: '10%', paddingBottom: '10%' }} >
                        <Grid item xs={12} >
                            <center>
                                <Typography>LOGIN</Typography>
                                <TextField
                                    className={classes.margin}
                                    id="username"
                                    placeholder="Username"
                                    variant="outlined"
                                    type="email"
                                    onChange={(event) => this.setState({ email: event.target.value, email_error: false, invalid_email_error: false, loginErrorMsg:"" })}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountCircle />
                                            </InputAdornment>
                                        ),
                                        classes: { input: classes.inputStyle }
                                    }}
                                    error={this.state.email_error === true ? true : this.state.invalid_email_error === true ? true : false}
                                    helperText={this.state.email_error === true ? "Please enter user name" : this.state.invalid_email_error === true ? "Please enter valid user name" : null}
                                    onKeyPress={(e) =>{ if (e.key === 'Enter') { this.submitForm()}}}
                                />
                            </center>
                        </Grid>
                        <Grid item xs={12} >
                            <center>
                                <TextField
                                    className={classes.margin}
                                    id="password"
                                    placeholder="Password"
                                    variant="outlined"
                                    type="password"
                                    onChange={(event) => this.setState({ password: event.target.value, password_error: false, invalid_password_error: false, loginErrorMsg:"" })}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Lock />
                                            </InputAdornment>
                                        ),
                                        classes: { input: classes.inputStyle }
                                    }}
                                    error={this.state.password_error === true ? true : this.state.invalid_password_error === true ? true : false}
                                    helperText={this.state.password_error === true ? "Please enter password" : this.state.invalid_password_error === true ? "Password must be 8 character" : null}
                                    onKeyPress={(e) =>{ if (e.key === 'Enter') { this.submitForm()}}}
                                />
                            </center>
                        </Grid>
                        <Grid item xs={12} >
                            <center>
                                <Button size="small" variant="contained" color="secondary" className={classes.button} onClick={this.submitForm}>
                                    Login
                                </Button>
                                <Typography onClick={() => this.handleOpen()} className={classes.typography}> Forogt password?</Typography>
                            </center>
                        </Grid>
                        <Grid item xs={12} >
                            <center style={{color: "red"}}>
                               {this.state.loginErrorMsg}
                            </center>
                        </Grid>
                        
                    </Grid>
                    : 
                    <Grid item xs={6} style={{ paddingTop: '10%', paddingBottom: '10%' }} >
                        <Grid item xs={12} >
                            <center>
                                <Typography>Forgot Password</Typography>
                                <TextField
                                    className={classes.margin}
                                    id="username"
                                    placeholder="Username"
                                    variant="outlined"
                                    type="email"
                                    onChange={(event) => this.setState({ email: event.target.value, email_error: false, invalid_email_error: false, loginErrorMsg: "" })}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountCircle />
                                            </InputAdornment>
                                        ),
                                        classes: { input: classes.inputStyle }
                                    }}
                                    error={this.state.email_error === true ? true : this.state.invalid_email_error === true ? true : false}
                                    helperText={this.state.email_error === true ? "Please enter user name" : this.state.invalid_email_error === true ? "Please enter valid user name" : null}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { this.forgotPasswordSubmit() } }}
                                />
                            </center>
                        </Grid>
                        <Grid item xs={12} >
                            <center>
                                <Button size="small" variant="contained" color="secondary" className={classes.button} onClick={this.forgotPasswordSubmit}>
                                    Submit
                                </Button>
                            </center>
                        </Grid>
                        <Grid item xs={12} >
                            <center style={{color: this.state.status !=="success" ? "red" : "green"}}>
                            {this.state.loginErrorMsg}
                            </center>
                        </Grid>
                        </Grid> }
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loginError: state.SessionReducer.loginError
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), connect(mapStateToProps))(Login);




